import { STATIC_URL } from 'constants/data'
import { Pagination } from 'swiper/modules'

const imgPaths = {
  mobile: {
    src: `${STATIC_URL}/intro-alt/doctor-mobile.png`,
    width: 375,
    height: 356,
    alt: 'Доктор',
  },
  desktop: {
    src: `${STATIC_URL}/intro-alt/doctor-desktop.png`,
    width: 233,
    height: 238,
    alt: 'Доктор',
  },
}

const ID_SWIPER = 'intro-material'
const swiperProps = {
  slidesPerView: 'auto',
  loop: true,
  speed: 500,

  pagination: { el: `#pagination-${ID_SWIPER}`, clickable: true as const },
  modules: [Pagination],
  spaceBetween: '5px',
}

export { imgPaths, ID_SWIPER, swiperProps }
